import { useRouteParams } from './useRouteParams';
import { ProviderType } from '../DocumentVault.meta';
import { useIsDocumentVaultReadOnly } from './useIsDocumentVaultReadOnly';
import { useListEntitiesQuery } from '../api/useListEntitiesQuery';

export const useIsFolderReadOnly = () => {
  const { clientId, path, providerType, filterableByYear } = useRouteParams();

  const { data: folderData } = useListEntitiesQuery({
    clientId,
    path,
    providerType,
    filterableByYear,
  });

  const isDocumentVaultReadOnly = useIsDocumentVaultReadOnly();

  const isExternalFolder = providerType === ProviderType.External;

  return isDocumentVaultReadOnly || isExternalFolder || (folderData && folderData.isReadOnly);
};
